
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 3.333a6.667 6.667 0 100 13.333 6.667 6.667 0 000-13.333zM1.667 9.999a8.333 8.333 0 1116.666 0 8.333 8.333 0 01-16.666 0z","fill":"#CF4655"}}),_c('path',{attrs:{"d":"M10 11.666a.833.833 0 01-.834-.833v-5a.833.833 0 011.667 0v5c0 .46-.373.833-.833.833zM8.75 13.75a1.25 1.25 0 112.5 0 1.25 1.25 0 01-2.5 0z","fill":"#CF4655"}})])
          )
        }
      }
    